/**
 * Mailbox entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { Dayjs } from 'dayjs';

export class Mailbox extends BaseModel {
    public id: number | null = null;
    public created: Dayjs | null = null;
    public sender_id: number | null = null;
    public message_id: number | null = null;
    public message_type: string | null = null;
    public subject: string | null = null;
    public message_date: Dayjs | null = null;
    public action: string | null = null;
    public test_delivery_flag: boolean | null = null;
    public event: string | null = null;
    public event_type: string | null = null;
    public ech_message_type: string | null = null;
    public payload: string | null = null;
    public error: string | null = null;
    public delivered: boolean | null = null;
    public recipient: string | null = null;
    public recipient_stelle_id: number | null = null;
    public planning_permission_application_id: number | null = null;

    // View
    public recipient_display: string | null = null;
    public direction: string | null = null;

    mutations() {
        return {
            id: (id: number | null) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName() {
        return 'Mailbox';
    }
}

export class MailboxCollection extends BaseCollection<Mailbox> {
    protected modelCls = Mailbox;

    public getModelClassName(): string {
        return 'Mailbox';
    }
}
